// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_dmFPB","space21":"index_space21_zrDuE","space50":"index_space50_cz1N6"};